
import { collectMixin } from '@/mixins'

import foFooter from '@/components/footer/footer.vue'
import foHeader from '@/components/header/header.vue'
import { ClientPageType } from '@/constants'
import collectService from '@/services/collect/collectService'
import { SnackBarType } from '@/store/types'
import { COLLECT_STATUSES } from '@meltingpoint/shared-statuses'
import mixins from 'vue-typed-mixins'

const defaultBody = {
  informations: '',
}

export default mixins(collectMixin).extend({
  name: 'mp-drive-signal',
  components: {
    foHeader,
    foFooter,
  },
  data() {
    return {
      place: '',
      waiting: false,
      hasLoaded: false,
      hasBeenUpdated: false,
      isSubmittingEvent: false,
      body: {
        informations: '',
      },
      ClientPageType,
    }
  },
  async mounted() {
    try {
      const {
        query: { language },
      } = this.$route

      const languageToUse = language?.toString() || ''

      await this.getCollect(this.$route.name!, languageToUse)

      if (this.collect!.status === COLLECT_STATUSES.PICK_UP_OK) {
        this.$router.push({ name: ClientPageType.COLLECT.REPORT_PRESENCE_AT_DRIVE_SUCCESS })
      }

      if (this.collect!.status === COLLECT_STATUSES.AWAITING) {
        this.waiting = true
      }

      this.body = { ...defaultBody, ...this.clientPage!.config.body }
    } catch (e) {
      this.$store.dispatch('setSnackbar', {
        message: this.$t('messages.error'),
        type: SnackBarType.ERROR,
      })
    }

    this.hasLoaded = true
  },
  methods: {
    async submit() {
      try {
        this.isSubmittingEvent = true
        const response = await collectService.patchWaiting(this.$route.params.id, this.place)
        if (response.updated === true) {
          this.hasBeenUpdated = true
        }

        this.waiting = true
        this.isSubmittingEvent = false
      } catch (e) {
        this.$store.dispatch('setSnackbar', {
          message: e.message.includes('403')
            ? this.$t('messages.collectSignal')
            : this.$t('messages.error'),
          type: SnackBarType.ERROR,
        })
        this.isSubmittingEvent = false
      }
    },
  },
  watch: {
    clientPage: {
      deep: true,
      handler(next) {
        this.body = { ...defaultBody, ...next.config.body }
      },
    },
  },
})
